* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
}

gz-tooltip {
  display: inline-block;
  width: 100%;
}
